import AnnotationOverlays from './AnnotationOverlays';
import { RenderAdapter } from '~/viewportGrid/adapters/types';
import { usePlaneViewOf } from '../usePlaneViewOf';

interface TileAnnotationMountProps {
    renderer: RenderAdapter;
}

/**
 * Mounts the annotation overlays (measurements, line profiles and circles)
 * over one grid tile, driven by the tile's engine view. Each overlay decides
 * membership itself, by the annotation's series and orientation against the
 * view's, so an annotation drawn on one tile shows on every tile of that
 * series and orientation, and never on a tile of another image.
 * Renders nothing for non-engine renderers (the mock adapters).
 */
export default function TileAnnotationMount({
    renderer,
}: TileAnnotationMountProps) {
    const view = usePlaneViewOf(renderer);
    if (!view) {
        return null;
    }
    return <AnnotationOverlays view={view} />;
}
